import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const ChevronUpIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 25 25" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.6304 16.3143C20.2399 16.7048 19.6068 16.7048 19.2162 16.3143L12.9233 10.0214L6.63045 16.3143C6.23992 16.7048 5.60676 16.7048 5.21623 16.3143C4.82571 15.9237 4.82571 15.2906 5.21623 14.9L12.2162 7.90004C12.6068 7.50952 13.2399 7.50952 13.6304 7.90004L20.6304 14.9C21.021 15.2906 21.021 15.9237 20.6304 16.3143Z"
            />
        </SvgIcon>
    );
};

export default ChevronUpIcon;
